import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function ModelSmokeTestCard({ answer }: Props) {
  const failed = answer.kind === 'model_smoke_test_failed';

  return (
    <article
      className={`rounded-lg border p-4 text-sm ${
        failed
          ? 'border-amber-200 bg-amber-50 text-amber-900'
          : 'border-sky-200 bg-sky-50 text-sky-900'
      }`}
    >
      <div className="mb-2 flex items-center gap-2">
        <span
          className={`rounded px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
            failed ? 'bg-amber-200 text-amber-900' : 'bg-sky-200 text-sky-900'
          }`}
        >
          {failed ? 'Model check failed' : 'Model check'}
        </span>
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
